import React, { useEffect, useMemo, useRef, useState } from "react";

import axios from "axios";
import base_url from "../../../api/bootapi";

import debounce from "lodash.debounce";
import SearchIcon from "@mui/icons-material/Search";
import "./flightWeather.css";
import { AcUnit } from "@mui/icons-material";
import { Loader } from "@mantine/core";
import Nav1 from "../../NavBar/Nav";

import AirportWeather from "./AirportWeather";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { ReactComponent as SmallCrossIcon } from "../../../assets/fi-rr-cross-small.svg";

const FlightWeather = () => {
  const [loading, setLoading] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [airport, setAirport] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [iata, setIata] = useState("");
  const [airportName, setAirportName] = useState("");

  const [airportWeatherData, setAirportWeatherData] = useState([]);
  console.log(airportWeatherData);
  const debouncedLoadOptions = useMemo(
    () =>
      debounce((value, callback) => {
        loadOptions(value, callback);
      }, 200),
    []
  );

  const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

  const fetchAirports = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/airport_list?search=${inputValue}&sortby=airport_name`
        );
        if (response.data && response.data.Airports) {
          return response.data.Airports.map((airport) => ({
            name: airport.name,
            shortName: airport.shortName,
            municipalityName: airport.municipalityName,
            iata: airport.iata,
            timeZone: airport.timeZone,
          }));
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }
    return [];
  };

  const fetchWeather = async () => {
    if (!airport) {
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/airport_weather?code=${iata}&timezone=${timeZone}`
      );

      console.log(response.data.data);
      setLoading(false);
      setAirportWeatherData(response.data.data);
      setAirportName(airport.name);
    } catch (error) {
      setAirportWeatherData([]);
      console.error("Error fetching airports:", error);
      setLoading(false);
    }
  };

  const handleCross = () => {
    setAirport("");
    setIata("");
    setTimeZone("");
  };

  return (
    <div>
      <Nav1 />

      <div className="weather-wrapper">
        <h2
          className="header"
          style={{ textAlign: "center", marginBottom: "50px" }}
        >
          Check Weather
        </h2>

        <div className="weather-dropdown">
          <SearchIcon />

          <input
            type="text"
            placeholder="Search airports"
            className="airportInput"
            autoFocus
            value={airport}
            onChange={(e) => {
              const inputValue = e.target.value;

              setAirport(inputValue);
              debouncedLoadOptions(inputValue, (options) => {
                setDefaultOptions(options);
              });
            }}
          />
          {airport && <SmallCrossIcon onClick={() => handleCross()} />}
          {defaultOptions.length > 0 && (
            <div className="search-flight-list">
              {defaultOptions.length > 0 ? (
                defaultOptions.map((option, i) => (
                  <span
                    className="flight-dropdown-item"
                    key={i}
                    onClick={(e) => {
                      e.stopPropagation();
                      setAirport(option.name);
                      setTimeZone(option.timeZone);
                      setIata(option.iata);
                      setDefaultOptions([]);
                    }}
                  >
                    {option.name}{" "}
                    <span className="iata_code">({option.iata})</span>
                  </span>
                ))
              ) : (
                <span
                  style={{
                    padding: "10px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  No matching locations found
                </span>
              )}
            </div>
          )}
          <button className="check-weather-btn" onClick={fetchWeather}>
            <AcUnit /> Check
          </button>
        </div>

        <div className="weather-listing-wrapper">
          {loading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Loading...
              <Loader color="blue" />
            </div>
          )}

          {!loading && airportWeatherData.length === 0 && (
            <div style={{ textAlign: "center" }}>No Data Found</div>
          )}
          <div className="weather-list-listt">
            {!loading && airportWeatherData.length > 0 && (
              <Swiper
                style={{ padding: "0px 20px" }}
                spaceBetween={20}
                breakpoints={{
                  640: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 4 },
                }}
                navigation={true}
                modules={[Navigation]}
                className="mySwiper"
              >
                {airportWeatherData.map((weather, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <AirportWeather
                        weather={weather}
                        name={airportName}
                        key={index}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlightWeather;
